// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-wrapper {
  
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    padding: 20px 30px;
}

.icon-card {

    padding: 10px 20px;
    width: 32%;
}

.icon-card:hover {
    background-color: #ffffff;
    border-radius: 20px 0 20px 0;
    box-shadow:
    0.3px 0.7px 2.7px rgba(0, 0, 0, 0.037),
    0.9px 1.7px 6.9px rgba(0, 0, 0, 0.053),
    1.8px 3.5px 14.2px rgba(0, 0, 0, 0.067),
    3.7px 7.3px 29.2px rgba(0, 0, 0, 0.083),
    10px 20px 80px rgba(0, 0, 0, 0.12)
  ;
  transition: all 0.30s;
}

.icon-card h4 {
    color: #20536F;
}

.icon-card p {
    font-size: 14px;
    color: #000000;
}

.icon-card img {
    width: 25%;

}

.hover{
    background-color: #ffffff;
    border-radius: 20px;

    box-shadow:
    0.3px 0.7px 2.7px rgba(0, 0, 0, 0.037),
    0.9px 1.7px 6.9px rgba(0, 0, 0, 0.053),
    1.8px 3.5px 14.2px rgba(0, 0, 0, 0.067),
    3.7px 7.3px 29.2px rgba(0, 0, 0, 0.083),
    10px 20px 80px rgba(0, 0, 0, 0.12)
  ;
}
.hover:hover{
    background-color: #ffffff;
    border-radius: 20px;
    box-shadow: none;
    transition: all 0.50s;
}





/* Responsive For Tablet Screen size 767px to 1023px START */
@media (max-width:1023px) {
    .icon-wrapper{
        margin-top: 730px;
        padding: 20px 50px;
     
    }

    .icon-card {

        padding: 10px 20px;
        width: 30%;
    }
   

}

/* Responsive For Tablet Screen size 601px to 1023px END */


@media (max-width:1023px) {

    .icon-wrapper{
        margin-top:730px;
       
     
    }

    
    }
    
@media (max-width:850px) {

    .icon-wrapper{
        margin-top:650px;
       
     
    }

    
    }
    


/* Responsive For Mobile Screen size 1024px to 1920px START */
@media (max-width:767px) {
    .icon-wrapper{
        margin-top:750px;
        padding: 20px 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 30px;
     
    }

    .icon-card {

        padding: 10px 20px;
        width: 100%;
    }
 
    .icon-card img {
        width: 20%;
    
    }

}
@media (max-width:735px) {
    .icon-wrapper{
        margin-top:680px;
    }

}
@media (max-width:550px) {
    .icon-wrapper{
        margin-top:600px;
    }


}
@media (max-width:450px) {
    .icon-wrapper{
        margin-top:730px;
        
     
    }
}
@media (max-width:370px) {
    .icon-wrapper{
        margin-top:900px;
        
     
    }

   

}

/* Responsive For Mobile Screen size 1024px to 1920px END */`, "",{"version":3,"sources":["webpack://./src/Components/IconcardStyles.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B;;;;;;EAMF;EACA,qBAAqB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;;IAEnB;;;;;;EAMF;AACF;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;;;;;AAMA,4DAA4D;AAC5D;IACI;QACI,iBAAiB;QACjB,kBAAkB;;IAEtB;;IAEA;;QAEI,kBAAkB;QAClB,UAAU;IACd;;;AAGJ;;AAEA,0DAA0D;;;AAG1D;;IAEI;QACI,gBAAgB;;;IAGpB;;;IAGA;;AAEJ;;IAEI;QACI,gBAAgB;;;IAGpB;;;IAGA;;;;AAIJ,6DAA6D;AAC7D;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;;IAEb;;IAEA;;QAEI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,UAAU;;IAEd;;AAEJ;AACA;IACI;QACI,gBAAgB;IACpB;;AAEJ;AACA;IACI;QACI,gBAAgB;IACpB;;;AAGJ;AACA;IACI;QACI,gBAAgB;;;IAGpB;AACJ;AACA;IACI;QACI,gBAAgB;;;IAGpB;;;;AAIJ;;AAEA,2DAA2D","sourcesContent":[".icon-wrapper {\n  \n    width: 100%;\n    height: auto;\n    display: flex;\n    justify-content: space-between;\n    padding: 20px 30px;\n}\n\n.icon-card {\n\n    padding: 10px 20px;\n    width: 32%;\n}\n\n.icon-card:hover {\n    background-color: #ffffff;\n    border-radius: 20px 0 20px 0;\n    box-shadow:\n    0.3px 0.7px 2.7px rgba(0, 0, 0, 0.037),\n    0.9px 1.7px 6.9px rgba(0, 0, 0, 0.053),\n    1.8px 3.5px 14.2px rgba(0, 0, 0, 0.067),\n    3.7px 7.3px 29.2px rgba(0, 0, 0, 0.083),\n    10px 20px 80px rgba(0, 0, 0, 0.12)\n  ;\n  transition: all 0.30s;\n}\n\n.icon-card h4 {\n    color: #20536F;\n}\n\n.icon-card p {\n    font-size: 14px;\n    color: #000000;\n}\n\n.icon-card img {\n    width: 25%;\n\n}\n\n.hover{\n    background-color: #ffffff;\n    border-radius: 20px;\n\n    box-shadow:\n    0.3px 0.7px 2.7px rgba(0, 0, 0, 0.037),\n    0.9px 1.7px 6.9px rgba(0, 0, 0, 0.053),\n    1.8px 3.5px 14.2px rgba(0, 0, 0, 0.067),\n    3.7px 7.3px 29.2px rgba(0, 0, 0, 0.083),\n    10px 20px 80px rgba(0, 0, 0, 0.12)\n  ;\n}\n.hover:hover{\n    background-color: #ffffff;\n    border-radius: 20px;\n    box-shadow: none;\n    transition: all 0.50s;\n}\n\n\n\n\n\n/* Responsive For Tablet Screen size 767px to 1023px START */\n@media (max-width:1023px) {\n    .icon-wrapper{\n        margin-top: 730px;\n        padding: 20px 50px;\n     \n    }\n\n    .icon-card {\n\n        padding: 10px 20px;\n        width: 30%;\n    }\n   \n\n}\n\n/* Responsive For Tablet Screen size 601px to 1023px END */\n\n\n@media (max-width:1023px) {\n\n    .icon-wrapper{\n        margin-top:730px;\n       \n     \n    }\n\n    \n    }\n    \n@media (max-width:850px) {\n\n    .icon-wrapper{\n        margin-top:650px;\n       \n     \n    }\n\n    \n    }\n    \n\n\n/* Responsive For Mobile Screen size 1024px to 1920px START */\n@media (max-width:767px) {\n    .icon-wrapper{\n        margin-top:750px;\n        padding: 20px 40px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 30px;\n     \n    }\n\n    .icon-card {\n\n        padding: 10px 20px;\n        width: 100%;\n    }\n \n    .icon-card img {\n        width: 20%;\n    \n    }\n\n}\n@media (max-width:735px) {\n    .icon-wrapper{\n        margin-top:680px;\n    }\n\n}\n@media (max-width:550px) {\n    .icon-wrapper{\n        margin-top:600px;\n    }\n\n\n}\n@media (max-width:450px) {\n    .icon-wrapper{\n        margin-top:730px;\n        \n     \n    }\n}\n@media (max-width:370px) {\n    .icon-wrapper{\n        margin-top:900px;\n        \n     \n    }\n\n   \n\n}\n\n/* Responsive For Mobile Screen size 1024px to 1920px END */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
